// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Radio, RadioGroup } from 'informed';

import {
  addGlucoseTest,
  deleteGlucoseTest,
  updateGlucoseTest,
} from '../../../actions/testingActions';

import DateText from '../../DateText.jsx';
import NumericText from '../../NumericText.jsx';
import Table from '../../Table.jsx';
import { Error } from '../../Typography.jsx';

type Props = {
  glucoseTests: Object[],
  activePatientId: string,
  addGlucoseTest: Function,
  deleteGlucoseTest: Function,
  updateGlucoseTest: Function,
}

class GlucoseTestsComponent extends Component<Props> {
  LOW_THRESHOLD = 3;

  HIGH_THRESHOLD = 8;

  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteGlucoseTest(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateGlucoseTest(this.props.activePatientId, {
      testId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addGlucoseTest(this.props.activePatientId, formData.values);
  }

  render() {
    let { glucoseTests } = this.props;
    glucoseTests = glucoseTests.map((item, index) => ({
      testNum: glucoseTests.length - index, ...item,
    }));

    const columns = [{
      Header: '',
      id: 'index',
      cell: item => `Test #${item.testNum ? item.testNum : ''}`,
      width: 80,
    }, {
      Header: 'Date',
      id: 'date',
      cell: item => (item.date ? moment(item.date).format() : '--'),
      editCell: item => <DateText field='date' item={item} />,
    }, {
      Header: 'Type',
      id: 'type',
      editCell: item => (
        <RadioGroup field='type' initialValue={item.type}>
          <Radio value={'Blood'} />Blood
          <br />
          <Radio value={'Urine'} />Urine
        </RadioGroup>
      ),
    }, {
      Header: 'Result',
      id: 'result',
      cell: (item) => {
        // handle 0 separately due to its evaluation to false
        if (item.result === 0) {
          return <Error>0 mmoL/L (L)</Error>;
        }
        return (
          item.result && (item.result < this.LOW_THRESHOLD || item.result > this.HIGH_THRESHOLD)
            ? <Error>{`${item.result} mmoL/L (${item.result < this.LOW_THRESHOLD ? 'L' : 'H'})`}</Error>
            : `${item.result || '--'} mmoL/L`);
      },
      editCell: item => <span>
        <NumericText field='result' initialValue={item.result} size={4} /> mmoL/L
      </span>,
    }];

    return (
      <div>
        <Table
          columns={columns}
          data={glucoseTests}
          handleDeleteRow={this.handleDeleteRow}
          handleSaveRow={this.handleSaveRow}
          handleSaveNewRow={this.handleSaveNewRow}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  glucoseTests: state.patient.data.testing.glucoseTests,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addGlucoseTest: (patientId, glucoseTest) => dispatch(
    addGlucoseTest(patientId, glucoseTest),
  ),
  deleteGlucoseTest: (patientId, glucoseTestId) => dispatch(
    deleteGlucoseTest(patientId, glucoseTestId),
  ),
  updateGlucoseTest: (patientId, glucoseTest) => dispatch(
    updateGlucoseTest(patientId, glucoseTest),
  ),
});

const GlucoseTests = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlucoseTestsComponent);

export default GlucoseTests;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/GlucoseTests.jsx